import React from "react";
import { Button } from "@vkontakte/vkui";
import { Icon28NotificationAddOutline } from "@vkontakte/icons";

export const MessageButtonAllow = ({callBack, hiddenIcon = false}) => <Button
	onClick={callBack}
	size="m" before={!hiddenIcon && <Icon28NotificationAddOutline/>}>Включить уведомления VK</Button>
